module.exports = __webpack_public_path__ + "img/layers.c73300d7.png";